export const musicDB = [
  {
    id: 1001,
    title: "Rolling Down the Road",
    artist: "T.J. Fortson",
    album: "Rolling Down the Road",
    src: "/TJ-Forston-RollingDownTheRoad-final.mp3",
    art: "/AlbumCover.jpeg",
    lyrics: [
      {
        time: 15.89,
        text: "Packed my bags in Michigan,\nlast night of seventy-nine",
      },
      {
        time: 19.34,
        text: "Pointed south toward Houston\nwith big dreams on my mind",
      },
      {
        time: 23.06,
        text: "New Year's morning, nineteen-eighty,\nTexas sun was burning bright",
      },
      {
        time: 29.97,
        text: "Started pushing cars at National\n— I knew it would be alright",
      },
      {
        time: 37.13,
        text: "Rolling down the road,\nfifty years and counting strong",
      },
      {
        time: 40.32,
        text: "From the gulf coast rigs to the Emerald Aisle,\nI always knew where I belonged",
      },
      {
        time: 44.58,
        text: "National gave me my start,\nand Voyager called me home",
      },
      {
        time: 47.51,
        text: "Rolling down the road\n— but I never drove alone",
      },
      {
        time: 60.24,
        text: "Met my Maryanne one night\nin a North Houston bar",
      },
      {
        time: 63.97,
        text: "Eighty-two turned into forever\n— she became my guiding star",
      },
      {
        time: 67.69,
        text: "Two kids watched their daddy\nchase that fleet card dream",
      },
      {
        time: 71.41,
        text: "Fifty years of fuel and wheels,\nthe biggest ride I've ever seen",
      },
      {
        time: 74.86,
        text: "Rolling down the road,\nfifty years and counting strong",
      },
      {
        time: 77.51,
        text: "From the gulf coast rigs to the Emerald Aisle,\nI always knew where I belonged",
      },
      {
        time: 81.50,
        text: "National gave me my start,\nand Voyager called me home",
      },
      {
        time: 84.68,
        text: "Rolling down the road\n— but I never drove alone",
      },
      {
        time: 97.17,
        text: "Doug called in twenty-twelve, said\n\"We need you one more time\"",
      },
      {
        time: 100.89,
        text: "Second tour at US Bank,\nI was ready for that climb",
      },
      {
        time: 104.35,
        text: "Joy and Terie stood beside me,\nAngela and Eric too",
      },
      {
        time: 108.06,
        text: "Supports who became my friends\n— I'm forever grateful to you",
      },
      {
        time: 111.51,
        text: "Started in the rental wars,\nlearned to fight for every win",
      },
      {
        time: 114.71,
        text: "US Bank and Voyager days\n— that's where the real road begins",
      },
      {
        time: 118.15,
        text: "Angela's team could roll out a deal,\nFrancine kept Salesforce records real",
      },
      {
        time: 121.87,
        text: "Wouldn't trade a single mile\nor a single friend I made",
      },
      {
        time: 125.33,
        text: "Rolling off the highway now,\nHouston down to Durango way",
      },
      {
        time: 130.64,
        text: "Classic cars are waiting\n— Lord, I've earned this sunny day",
      },
      {
        time: 134.36,
        text: "Fifty years of transportation,\nwhat a hell of a ride",
      },
      {
        time: 138.08,
        text: "Rolling down the road,\nwith Maryanne right by my side",
      },
      {
        time: 141.53,
        text: "Fifty years of transportation,\nwhat a hell of a ride",
      },
      {
        time: 146.84,
        text: "Rolling down the road,\nwith Maryanne right by my side",
      },
      {
        time: 161.71,
        text: "...with Maryanne\nright by my side.",
      },
    ],
  },
];
